
















































































































import {
	PredicateDefinition,
	ReportPrintQueryModel,
	ReportPrintTypeEnum,
	WorkTaskStatementModel
} from '@/libs/Api';
import Page from '@/Page.vue';
import {Component} from 'vue-property-decorator';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {workTaskStatementsStore} from '@/libs/work-task-statements/+state/store';
import moment from "moment/moment";
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";

@Component({
	components: {}
})
export default class ReportDialogReceipts extends Page {

	private dialog = false;
	private fromDate: string | null = null;
	private toDate: string | null = null;
	private predicates: PredicateDefinition[] = [];
	printing = false;

	report: any = null;

	open (fromDate: string, toDate: string, predicates: PredicateDefinition[]) {
		this.dialog = true;
		this.fromDate = fromDate;
		this.toDate = toDate;
		this.predicates = predicates;
		this.report = null;
		this.loadReport();
	}

	get workTaskStatements(): WorkTaskStatementModel[] {
		return workTaskStatementsStore.useGetter(CrudGetter.Data, "ClosingDialog");
	}

	get loading(): boolean {
		return workTaskStatementsStore.useGetter(CrudGetter.Pending, "ClosingDialog");
	}

	loadReport() {
		const query = {
			predicates: this.predicates as PredicateDefinition[],
			orderby: [
				{ field: "fromDate", index: 1, order: "desc"}
			],
			fileName: "Strvzenky po klietech",
			printType: ReportPrintTypeEnum.Receipts,
			date: moment().add(-1, "day").format("YYYY-MM-DDT00:00:00"),
			fromDate: moment(this.fromDate).format("YYYY-MM-DDT00:00:00"),
			toDate: moment(this.toDate).format("YYYY-MM-DDT23:59:59")
		} as ReportPrintQueryModel;
		ApiService.api.reportBatch(query).then((x: any) => {
			const res = x.data;
			this.report = res.returnValue;
		});
	}

	printReport() {
		this.printing = true;
		const query = {
			predicates: this.predicates as PredicateDefinition[],
			orderby: [
				{ field: "fromDate", index: 1, order: "desc"}
			],
			fileName: "Strvzenky po klietech",
			printType: ReportPrintTypeEnum.Receipts,
			date: moment().add(-1, "day").format("YYYY-MM-DDT00:00:00"),
			fromDate: moment(this.fromDate).format("YYYY-MM-DDT00:00:00"),
			toDate: moment(this.toDate).format("YYYY-MM-DDT23:59:59")
		} as ReportPrintQueryModel;
		ApiService.api.printReportBatch(query).then((x: any) => {
			this.printing = false;
			const res = x.data;
			const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.setAttribute('download', res.returnValue.filename!);
			document.body.appendChild(link);
			link.click();
			link.parentNode!.removeChild(link);
		}).catch(() => {
			this.printing = false;
		});
	}

	close () {
		this.dialog = false;
	}

}
